import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"width":"500px","max-height":"500px","overflow":"hidden","display":"flex","flex-direction":"column","justify-content":"space-between"} }
const _hoisted_2 = { style: {"flex":"1","overflow":"hidden","overflow-y":"scroll"} }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "s1 mt-1" }
const _hoisted_5 = ["name", "id", "value"]
const _hoisted_6 = { class: "s16 pl-2 secondary-font" }
const _hoisted_7 = { class: "secondary-font text-grey-600" }
const _hoisted_8 = ["disabled"]

import { ref } from 'vue';
    import MarketCheckoutAdresseFormModal from './MarketCheckoutAdresseFormModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCheckoutAdressesListModal',
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const selectedAdresse = ref(null as any);
    const selectedAdresseId = ref(null as number | null);
    const adressesList = ref([] as any[]);
    const adresseFormModalRef = ref<InstanceType<typeof MarketCheckoutAdresseFormModal> | null>(null);

    async function open(adresses?: any, openForm = false) {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        adressesList.value = adresses || [];
        if (openForm) {
            await openAdresseFormModal();
        }
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    async function onSubmit() {
        if (!selectedAdresseId.value) { return; }
        resolvePromise(selectedAdresse.value);
        isModalOpen.value = false;
    }

    function onAdresseSelected() {
        const adresse = adressesList.value.find(a => a.id === selectedAdresseId.value);
        selectedAdresse.value = adresse || null;
    }

    async function openAdresseFormModal(adresse?: any) {
        const adresseSaved = await adresseFormModalRef.value?.open(adresse);
        if (adresseSaved) {
            const index = adressesList.value.findIndex((a: any) => a.id === adresseSaved.id);
            if (index !== -1) {
                adressesList.value[index] = adresseSaved;
                adressesList.value = [...adressesList.value];
            } else {
                adressesList.value.push(adresseSaved);
            }
            selectedAdresseId.value = adresseSaved.id;
            onAdresseSelected();
        }
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_custom_modal, {
      show: isModalOpen.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isModalOpen).value = $event)),
      onClosed: onClose
    }, {
      header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"flex":"1","display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
          _createElementVNode("h4", { class: "font-semibold" }, "Adresses de livraison")
        ], -1)
      ]))]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          id: "btn-confirmation-confirm",
          class: "btn lg stroke",
          style: {"justify-content":"center"},
          onClick: onSubmit,
          disabled: !selectedAdresseId.value
        }, "Valider", 8, _hoisted_8),
        _createElementVNode("button", {
          id: "btn-confirmation-reject",
          class: "btn lg white2",
          style: {"justify-content":"center"},
          onClick: onClose
        }, "Annuler")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "btn lg stroke w-100 flex-center",
            onClick: openAdresseFormModal
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "Ajouter une nouvelle adresse", -1)
          ]))]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adressesList.value, (adresse, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6", {'active': selectedAdresse.value?.id === adresse.id}]),
                key: index
              }, [
                _createElementVNode("label", {
                  class: "s20",
                  for: 'adresse_' + index
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      type: "radio",
                      name: 'super_' + index,
                      id: 'adresse_' + index,
                      value: adresse.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAdresseId).value = $event)),
                      onChange: onAdresseSelected
                    }, null, 40, _hoisted_5), [
                      [_vModelRadio, selectedAdresseId.value]
                    ])
                  ]),
                  _createElementVNode("h5", _hoisted_6, [
                    _createTextVNode(_toDisplayString(adresse.libelle) + " ", 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(adresse.adresse) + " ", 1),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(_toDisplayString(adresse.telephone), 1)
                    ])
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "s3 text-right" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-livraison-relais.svg",
                      class: "size-base",
                      alt: ""
                    })
                  ], -1))
                ], 8, _hoisted_3)
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(MarketCheckoutAdresseFormModal, {
      ref_key: "adresseFormModalRef",
      ref: adresseFormModalRef
    }, null, 512)
  ], 64))
}
}

})